import { SectionBoxStyled } from '@OnArk/styles/Form.styled';
import { SectionStyled } from '@OnArk/styles/Layout.styled';

import React, { ReactElement } from 'react';

import { css } from '@emotion/react';
import { MaxWidthStyled, mq } from '@hangar31/rc-layout';
import { PageProps, SectionContextProvider } from '@OnArk/contexts/section';
import GuestNav from '@OnArk/global/GuestNav';
import withClient from 'graphql/withClient';

import SectionListWrapper from '../Course/SectionListWrapper';
import { WALKTHROUGH_ENABLED } from '../GettingStarted/enabled';
import SectionTypeTour from '../GettingStarted/SectionTypeTour';

import SectionSidebar from './Navs/SectionSidebar';
import SectionTopbar from './Navs/SectionTopbar';
import DesktopHandoffBanner from './DesktopHandoffBanner';

const SectionLayout = ({
  children,
  ...props
}: React.PropsWithChildren<PageProps>): ReactElement => {
  return (
    <SectionContextProvider {...props}>
      <SectionListWrapper>
        <SectionSidebar />
      </SectionListWrapper>
      <SectionBoxStyled
        css={css`
          position: relative;

          height: auto;
          min-height: calc(100vh - 61px);
          padding-top: 0 !important;
          padding-right: 0 !important;
          padding-left: 0 !important;
        `}
      >
        <SectionTopbar icon={`SECTIONS_${props.currentSection.type}`} />
        <SectionStyled css={mq({ padding: ['0.8rem', undefined, '1.5rem'] })}>
          <GuestNav
            church={props.church}
            course={{
              name: props.course.name,
              sections: props.sections,
              url: props.course.url,
            }}
            css={mq({
              'a, div': { pointerEvents: 'none' },
              // The in-builder GuestNav is purely a decorative preview
              // (pointer events disabled). On phones it eats most of the
              // viewport without giving anything actionable, so hide it.
              display: ['none', undefined, 'block'],
            })}
            currentSection={props.currentSection}
            locale={props.locale}
          />
          <MaxWidthStyled grid as="section" size="sm">
            <DesktopHandoffBanner />
            {children}
          </MaxWidthStyled>
        </SectionStyled>
      </SectionBoxStyled>
      {WALKTHROUGH_ENABLED && (
        <SectionTypeTour type={props.currentSection.type} />
      )}
    </SectionContextProvider>
  );
};

export default withClient(SectionLayout);
